import { ArrowUpRight } from "../../../components/svgs";

const AboutCtaSection = () => {
  return (
    <section className="bg-primary text-white py-16 md:py-20 px-4">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-10">
        <div className="max-w-2xl">
          <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
            Start with Utiva
          </p>
          <h2 className="text-white font-poppins font-bold tracking-[-0.03em] leading-tight text-3xl md:text-4xl lg:text-5xl m-0">
            Your next opportunity—or your next great team—can start here.
          </h2>
        </div>

        <div className="grid gap-3 w-full sm:w-auto min-w-[230px]">
          <a
            href="/school"
            className="bg-secondary text-primary font-poppins font-extrabold rounded-xl flex items-center justify-between gap-4 px-5 py-4 custom-btn"
          >
            Explore programs <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
          <a
            href="/hire"
            className="text-white text-center font-poppins font-bold underline decoration-white decoration-2 underline-offset-4 hover:opacity-80 transition-opacity"
          >
            Talk to our talent team →
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutCtaSection;
